import { render, staticRenderFns } from "./order-refund.vue?vue&type=template&id=e87d63b0&scoped=true"
import script from "./order-refund.vue?vue&type=script&lang=js"
export * from "./order-refund.vue?vue&type=script&lang=js"
import style0 from "./order-refund.vue?vue&type=style&index=0&id=e87d63b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87d63b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e87d63b0')) {
      api.createRecord('e87d63b0', component.options)
    } else {
      api.reload('e87d63b0', component.options)
    }
    module.hot.accept("./order-refund.vue?vue&type=template&id=e87d63b0&scoped=true", function () {
      api.rerender('e87d63b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Order/order-refund.vue"
export default component.exports